import { createAsyncThunk, createSlice,type  PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { ItemsBySupplierModels } from './Models';

export const ItemSupplierInItem = createAsyncThunk(
  'itemsSupplier/ItemSupplierInItem',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/ItemSupplierInItem', item);

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddItemSupplier = createAsyncThunk(
  'itemsSupplier/AddItemSupplier',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/AddItemSupplier', item);

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeleteItemSupplier = createAsyncThunk(
  'itemsSupplier/DeleteItemSupplier',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Inv/DeleteItemSupplier', item);

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getItemsBySupplierId = createAsyncThunk(
  'itemsSupplier/getItemsBySupplierId',
  async (supplierId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(
        `Inv/GetInventoryItemsBySupplierId?SupplierId=${supplierId}`
      );
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  ItemsBySupplier: ItemsBySupplierModels[];
  loading: boolean;
  error: any | null;
} = {
  ItemsBySupplier: [],
  loading: false,
  error: null,
};

const ItemsSupplierSlice = createSlice({
  name: 'itemsSupplier',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getItemsBySupplierId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        getItemsBySupplierId.fulfilled,
        (state, action: PayloadAction<ItemsBySupplierModels[]>) => {
          state.loading = false;
          state.ItemsBySupplier = action.payload;
        }
      )
      .addCase(getItemsBySupplierId.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ItemsSupplierSlice.reducer;
